import EF from 'ef/ef';
import View from 'views/base/view';
import AssessmentService from 'services/data-handler-services/assessment-service';
import ProgressService from 'services/course-handler-services/progress-service';
import AssessmentTemplate from './templates/assessment';
import Chaplin from 'chaplin';
import _ from 'lodash';

const AssessmentView = View.extend({
  autoRender: true,
  autoAttach: true,
  template: AssessmentTemplate,
  className: 'card',
  listen: {
    addedToDOM: 'loaded',
  },
  render: function () {
    const model = {
      assessments: [],
    };

    model.assessments = EF.modules.reduce(function (memo, mod) {
      if (mod.get('assessment_slug')) {
        const aps = AssessmentService.getActivityProgressForSlug(mod.get('assessment_slug'), true);
        memo.push({
          slug: mod.get('assessment_slug'),
          moduleKey: mod.get('key'),
          progress: aps.length > 0,
          passed: aps ? _.some(aps, ap => ap.get('passed')) : false,
        });
      }
      if (mod.get('pre_assessment_slug')) {
        const aps = AssessmentService.getActivityProgressForSlug(mod.get('pre_assessment_slug'), true);
        memo.push({
          slug: mod.get('pre_assessment_slug'),
          moduleKey: mod.get('key'),
          progress: aps.length > 0,
          passed: aps ? _.some(aps, ap => ap.get('passed')) : false,
        });
      }
      return memo;
    }, []);
    this.model = new Chaplin.Model(model);

    View.prototype.render.apply(this, arguments);
  },
  loaded: function () {
    const self = this;
    this.delegate('click', '.btn-assess.bg-color-error-base', function (e) {
      const button = e.currentTarget;
      const slug = button.attributes['data-slug'].value;
      const moduleKey = button.attributes['data-module'].value;
      ProgressService.removeLocalActivityProgress(slug, moduleKey).done(() => {
        self.render();
        EF.activityProgresses.fetch();
      });
    });
    this.delegate('click', '.btn-assess.btn-success', function (e) {
      const button = e.currentTarget;
      const moduleKey = button.attributes['data-module'].value;
      const passed = !!button.attributes['data-pass'];
      ProgressService.saveLocalActivityProgress(
        {
          attempt: 1,
          enrollment_id: EF.enrollment.get('id'),
          grade: passed ? 100 : 10,
          passed: passed,
          slug: button.attributes['data-slug'].value,
        },
        moduleKey
      ).done(() => {
        self.render();
        EF.activityProgresses.fetch();
      });
    });
  },
});

export default AssessmentView;
